import {BuildVariables} from "Build.Common/Scripts/Generated/TFS.Build2.Common";


export var defaultTfvcPrefix = "$/";
export var defaultSourceLabelFormat = "$(" + BuildVariables.BuildNumber + ")";
